import * as _ from 'underscore';

export module Helpers {
  export const DEFAULT_LETTER_T = 'T';
  export interface ImageDimensions {
    width: number;
    height: number;
  }
  // Taken from httpd.conf (.*(?:\:|\%3A)embed=(y|yes|t|true|1).*)
  export let BooleanQueryParamRegex = /^[yt1]/i;
  export let BooleanQueryParamRegexFalse = /^[nf0]/i;

  export function isDefined(x: any) {
    return x !== null && x !== undefined;
  }

  export function ifDefined<InputT, ResultT, U = undefined>(
      value: InputT,
      fn: (value: InputT) => ResultT, defaultValue: U = undefined
  ): ResultT | U {

    if (!isDefined(value)) {
      return defaultValue;
    }
    return fn(value);
  }

  export function dictFromArray<T>(array: T[], key: string): _.Dictionary<T> {
    return <_.Dictionary<T>>_.object(_.pluck(array, key), array);
  }

  export function toBoolean(val: string): boolean {
    return val === 'true';
  }

  export function swapDict(map: _.Dictionary<any>): _.Dictionary<any> {
    return _.object<_.Dictionary<string>>(_.values(map),_.keys(map));
  }

  function isLetter(char: string): boolean {
    return char.length === 1 && char.match(/[a-z]/i) != null;
  }

  // Extract leading English letters from the first two words
  // Return T to represent Tableau if no letter can generated
  export function generateAbbrevFromName(displayName: string): string {
    if (!displayName) return DEFAULT_LETTER_T;
    let abbrev = '';
    const words = displayName.trim().split(/\ +/);
    for (let i = 0; i < words.length && i < 2; ++i) {
      const initial: string = words[i].charAt(0);
      if (isLetter(initial)) {
        abbrev += initial.toUpperCase();
      }
    }
    return abbrev !== ''? abbrev : DEFAULT_LETTER_T;
  }

  /**
   * Converts a snake case name into a camel case name.
   * If some of the input is already camel case, this will still work.
   */
  export function makeAngularDirectiveName(snakeCaseName: string): string {
    return snakeCaseName.replace(/([-_:][a-zA-Z])/g, ($1) => ($1.charAt(1).toUpperCase()));
  }

  export function calculateResizedDimensions(originalWidth: number, originalHeight: number,
                                             maxWidth: number, maxHeight: number): ImageDimensions {
    if (originalWidth > originalHeight && originalWidth > maxWidth) {
      originalHeight *= maxWidth / originalWidth;
      originalWidth = maxWidth;
    } else if (originalHeight > maxHeight) {
      originalWidth *= maxHeight / originalHeight;
      originalHeight = maxHeight;
    }
    return {
      width: originalWidth,
      height: originalHeight
    };
  }

  export function serialize(input: object): string{
    // convoluted cast because typescript thinks $.param is a string
    const serializer: (input: object) => string = jQuery.param as any;
    return serializer(input);
  }
}
